export const TEXT_AREA_MAX_LENGTH = 1000;
